import { Bar, ComposedChart, Label, Line, ReferenceDot, ResponsiveContainer, XAxis, YAxis } from 'recharts'

import { ComboData } from '@/types/page'

import styles from './ComboDistributionChart.module.scss'

type Props = {
  combo: ComboData
}

const ComboDistributionChart = ({ combo }: Props) => {
  let data = Object.entries(combo.rankDistribution).map(([key, value]) => ({
    name: Number(key),
    value,
  }))

  // Remove first item if not needed (it creates too much height on the chart)
  if (combo.count <= data[1].value) data.shift()
  // If we need the first item, remove the back portion of the chart to make it look better
  else data = data.slice(0, Math.ceil(data.length / 5))

  // The label switches from top to bottom at 50%
  let label = `Top ${((combo.rank / combo.totalComboCount) * 100).toFixed(2)}% of combos`
  if (combo.rank > combo.totalComboCount / 2)
    label = `Bottom ${(100 - (combo.rank / combo.totalComboCount) * 100).toFixed(2)}% of combos`

  // The label position switches from right to middle to left at 1/3s
  let dotLabelDY = -20
  let dotLabelDX = -95
  if (combo.rank > combo.totalComboCount - combo.totalComboCount / 3) {
    dotLabelDY = -10
    dotLabelDX = -205
  } else if (combo.rank < combo.totalComboCount / 3) {
    dotLabelDY = -10
    dotLabelDX = 0
  }

  return (
    <div className='position-relative mb-3'>
      <label className={styles.xlabel}>Combo Rank</label>
      <label className={styles.ylabel}>Decks</label>
      <ResponsiveContainer height={125} width='100%'>
        <ComposedChart data={data} height={250}>
          <XAxis dataKey='name' tick={{ fill: '#9e9e9e' }} type='number' />
          <YAxis tick={{ fill: '#9e9e9e' }} tickFormatter={(tick) => (tick ? `${tick / 1000}k` : tick)} type='number' />
          <Bar dataKey='value' fill='rgba(50,145,158,0.16)' />
          <ReferenceDot fill='#ff7300' isFront r={5} stroke='#ff7300' x={combo.rank} y={combo.count}>
            <Label dy={dotLabelDY} fill='#ff7300' offset={dotLabelDX} position='right' value={label} />
          </ReferenceDot>
          <Line dataKey='value' dot={false} stroke='#4e749c' type='monotone' />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}

export default ComboDistributionChart
